import DOMPurify from 'dompurify';

// Hook to strip dangerous URI schemes and force safe rel on links
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    const href = node.getAttribute('href') || '';
    const target = node.getAttribute('target') || '';
    // Strip javascript:, data:, vbscript:, file: schemes
    if (/^(javascript|data|vbscript|file):/i.test(href)) {
      node.removeAttribute('href');
    }
    // Force noopener noreferrer on links that open in new tab
    if (target === '_blank') {
      node.setAttribute('rel', 'noopener noreferrer nofollow');
    } else {
      node.setAttribute('rel', 'nofollow');
    }
  }
  if (node.tagName === 'IMG') {
    const src = node.getAttribute('src') || '';
    // Strip data: URIs in images (SVG-based XSS vector)
    if (/^data:/i.test(src)) {
      node.removeAttribute('src');
    }
  }
});

// Decode HTML entities (e.g. &lt;figure&gt; -> <figure>) in case the API
// returns escaped HTML strings instead of raw HTML.
const decodeHTMLEntities = (str) => {
  if (!str || typeof str !== 'string') return str;
  // Only decode if the string appears to contain escaped tags
  if (!/&lt;|&gt;|&amp;|&quot;|&#\d+;|&nbsp;/i.test(str)) return str;
  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
};

export const sanitizeHTML = (dirty) => {
  if (!dirty) return '';

  // Decode escaped HTML entities so tags render as actual HTML
  const decoded = decodeHTMLEntities(dirty);

  return DOMPurify.sanitize(decoded, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 'a', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'span', 'div', 'b', 'i', 'table', 'thead', 'tbody', 'tr', 'td', 'th',
      'blockquote', 'pre', 'code', 'img', 'figure'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'id', 'src', 'alt', 'title'],
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'textarea'],
    // Block ALL on* event handler attributes (not just a few)
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout',
      'onmousedown', 'onmouseup', 'onmousemove', 'onkeydown', 'onkeypress',
      'onkeyup', 'onfocus', 'onblur', 'onchange', 'onsubmit', 'onreset',
      'onselect', 'ondblclick', 'oncontextmenu', 'ondrag', 'ondragend',
      'ondragenter', 'ondragleave', 'ondragover', 'ondragstart', 'ondrop',
      'onscroll', 'onwheel', 'ontouchstart', 'ontouchmove', 'ontouchend',
      'ontouchcancel', 'oncopy', 'oncut', 'onpaste', 'onbeforecopy',
      'onbeforecut', 'onbeforepaste', 'onbeforeprint', 'onafterprint']
  });
};

export default sanitizeHTML;
